module.exports = __webpack_public_path__ + "img/1F638.84db9769.svg";